import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import ConversationTopicStatus from '@/models/ConversationTopics/ConversationTopicStatus';
import ConversationTopicType from '@/models/ConversationTopics/ConversationTopicType';
import DeskDto from '@/models/Desks/DeskDto';
import BranchDto from '@/models/Branches/BranchDto';
import BusinessHoursDto from '@/models/BusinessHours/BusinessHoursDto';
import AgencyGroupDto from '../AgencyGroups/AgencyGroupDto';


export default class ConversationTopicDto extends BaseAgencyScopeEntityDto {
    name = '';
	status: ConversationTopicStatus = ConversationTopicStatus.Active;
	type: ConversationTopicType = ConversationTopicType.Central;
    isPublic = false;
	isEnabled = true;
	avatar = '';
	branchId = '';
	branch: BranchDto = new BranchDto();
	deskId = '';
	desk: DeskDto = new DeskDto();
	businessHoursId = '';
	businessHours: BusinessHoursDto = new BusinessHoursDto();
	isBusinessHoursNotificationEnabled = false;
	businessHoursGroupId = '';
	businessHoursGroup: AgencyGroupDto = new AgencyGroupDto();
	isOutOfHoursNotificationEnabled = false;
	outOfHoursGroupId = '';
	outOfHoursGroup: AgencyGroupDto = new AgencyGroupDto();
	offlineMessage = '';
}